import { ArchiveArtefactConfirmDialog } from '@modules/common/components/ArchiveArtefactConfirmDialog';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import {
  NAV_PATHS,
  NOTIFICATION_TIMEOUT_LONG_6S,
} from '@modules/common/constants';
import { useIsSearchToFeedEnabled } from '@modules/common/hooks';
import { ArtefactType } from '@modules/common/types';
import { trackDashboardEvent } from '@modules/dashboard/helpers';
import { useUpdateDashboard } from '@modules/dashboard/hooks/useUpdateDashboard';
import { DashboardViewFragment, Status } from 'generated/graphql';
import { useCallback } from 'react';
import { redirect } from 'react-router-dom';

interface ArchiveDashboardFormProps {
  dashboard: DashboardViewFragment;
  dashboardType: ArtefactType;
}

export const ArchiveDashboardForm = ({
  dashboard,
  dashboardType,
}: ArchiveDashboardFormProps) => {
  const { showSuccessNotification } = useNotificationContext();
  const dashboardTitle = dashboard.title;
  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();

  const { updateDashboard } = useUpdateDashboard();
  const onArchive = useCallback(async () => {
    if (!dashboard) {
      return;
    }

    await updateDashboard({
      updateRequest: {
        id: dashboard.id,
        viewToken: dashboard.viewToken,
        editToken: dashboard.editToken || '',
        status: Status.Archived,
      },
    });

    if (dashboardType === ArtefactType.Search) {
      redirect(`/${isSearchToFeedEnabled ? NAV_PATHS.FEED : NAV_PATHS.SEARCH}`);
    }
    if (dashboardType === ArtefactType.Dashboard) {
      trackDashboardEvent({
        eventName: 'Dashboard Archived',
        dashboardLink: window.location.href,
      });
    }
    showSuccessNotification({
      contentComponent: `This ${dashboardType} has been archived`,
      props: { timeout: NOTIFICATION_TIMEOUT_LONG_6S, zIndex: 10000 },
    });
  }, [
    dashboard,
    dashboardType,
    isSearchToFeedEnabled,
    showSuccessNotification,
    updateDashboard,
  ]);

  return (
    <ArchiveArtefactConfirmDialog
      onArchive={onArchive}
      artefactTitle={dashboardTitle}
      artefactType={dashboardType}
    />
  );
};
